import { Injectable, Inject, HttpStatus, forwardRef } from '@nestjs/common';
import {  Raw, getConnection, Repository, Like, Not } from 'typeorm';
import { InjectRepository } from '@nestjs/typeorm'; 
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { ProfileEntity } from './profile.entity';
import { getMyNetworkResponseModel, GetProfilePicResponseModel, GetProfileResponseModel } from './dto/profile-response-model';
import { ProfileDTO } from './dto/profile.dto';
import { UserEntity } from '../user/user.entity';
import { errorHandler } from '@gtpl/shared-utils/error-messages';
import * as fs from 'fs';
import { WelfareService } from '../welfare/welfare.service';
import { BloodGroupEntity } from '../bloodgroup/blood-group.entity';

@Injectable()
export class ProfileService {
    constructor(
        @InjectRepository(ProfileEntity)
        private profileRepo: Repository<ProfileEntity>, 
        @InjectRepository(UserEntity)
        private userRepo: Repository<UserEntity>,
        @InjectRepository(BloodGroupEntity)
        private BGroupRepo:Repository<BloodGroupEntity>,
        @Inject(forwardRef(()=>WelfareService))
        private welfareService: WelfareService, 
    ) {}

    async createProfile(profileData) {
        try {
            const profile = await this.profileRepo.save(profileData);
            if(profile) {
                return profile;
            } else { 
                return null;                
            }        
        } catch (error) {
            throw error;
        }
    }

    async updateProfile(queryParams, filesData,memberPic,profileDto: ProfileDTO, request:Request): Promise<GetProfileResponseModel> {
        const response = new GetProfileResponseModel();        
        try {
            const checkProfileExe = await this.profileRepo.findOne({where:{userId:profileDto.userId}});
            if(filesData) {
                profileDto.profilePic = filesData[0];
            } else {
                profileDto.profilePic = checkProfileExe.profilePic
            }
            if(memberPic) {
                profileDto.membershipImg = memberPic[0];
            } else {
                profileDto.membershipImg = checkProfileExe.membershipImg;
            }
            if(profileDto.BGroupId > 0) {
                profileDto.BGroupId = profileDto.BGroupId
            } else {
                if(checkProfileExe) {
                    profileDto.BGroupId = checkProfileExe.BGroupId
                } else {
                    profileDto.BGroupId = null;
                }
            }
            if(profileDto.BloodDonner == true || profileDto.BloodDonner == false) {
                profileDto.BloodDonner = profileDto.BloodDonner
            } else {
                if(checkProfileExe) {
                    profileDto.BloodDonner = checkProfileExe.BloodDonner
                } else {
                    profileDto.BloodDonner = false;
                }
            }
            if(profileDto.roleId > 0) {
                await this.userRepo.update(profileDto.userId,{roleId:profileDto.roleId})
            }  
            if(profileDto.membershipId.length > 0) {
                await this.userRepo.update(profileDto.userId,{membershipId:profileDto.membershipId})
            }         
            if(queryParams.apiVersion == 1) {
                if(checkProfileExe) {
                    const updatedUser = await this.profileRepo.update(checkProfileExe.Id, profileDto);
                    if(updatedUser && profileDto.mobileNo != null) {
                        await this.userRepo.update({Id:profileDto.userId},{mobileNo:profileDto.mobileNo})
                    }
                    const updatedData = await this.profileRepo.findOne({
                        where:{Id:checkProfileExe.Id}
                    });
                    if(updatedUser) {
                        response.status = true;
                        response.data   = updatedData;
                        response.statusCode = 50000;
                        response.internalMessage = 'Profile updated successfully';
                        response.intlCode = 11108;
                    } else {
                        throw new ErrorResponse(99998, 'Profile update failed')
                    }
                } else {
                    const saveUser = await this.profileRepo.save(profileDto);
                    if(saveUser && profileDto.mobileNo != null) {
                        await this.userRepo.update({Id:profileDto.userId},{mobileNo:profileDto.mobileNo})
                    }
                    if(saveUser) {
                        response.status = true;
                        response.data   = saveUser;
                        response.statusCode = 50000;
                        response.internalMessage = 'Profile created successfully';
                        response.intlCode = 11108;
                    } else {
                        throw new ErrorResponse(99998, 'Profile creation failed')
                    }
                }
            } else {
                if(checkProfileExe) {
                    const updatedUser = await this.profileRepo.update(checkProfileExe.Id, profileDto);
                    if(updatedUser && profileDto.mobileNo != null) {
                        await this.userRepo.update({Id:profileDto.userId},{mobileNo:profileDto.mobileNo})
                    }
                    const updatedData = await this.profileRepo.findOne({
                        where:{Id:checkProfileExe.Id}
                    });
                    if(updatedUser) {
                        response.status = true;
                        response.data   = updatedData;
                        response.statusCode = 50000;
                        response.internalMessage = 'Profile updated successfully';
                        response.intlCode = 11108;
                    } else {
                        throw new ErrorResponse(99998, 'Profile update failed')
                    }
                } else {
                    const saveUser = await this.profileRepo.save(profileDto);
                    if(saveUser && profileDto.mobileNo != null) {
                        await this.userRepo.update({Id:profileDto.userId},{mobileNo:profileDto.mobileNo})
                    }
                    if(saveUser) {
                        response.status = true;
                        response.data   = saveUser;
                        response.statusCode = 50000;
                        response.internalMessage = 'Profile created successfully';
                        response.intlCode = 11108;
                    } else {
                        throw new ErrorResponse(99998, 'Profile creation failed')
                    }
                }
            }
            return response;
        } catch (error) {
            return errorHandler(GetProfileResponseModel, error);
        }
    }

    async updateProfilePic(queryParams, filesData, userId ): Promise<GetProfilePicResponseModel> {
        const response = new GetProfilePicResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const oldData = await this.profileRepo.findOne({
                    where:{userId:userId}
                });                
                if(oldData.profilePic != null) {
                    var pary = oldData.profilePic.split('/');
                    var fname = pary[2];
                    if(fname != undefined) {
                        fs.unlinkSync('./public/profilePic/'+fname);
                    }
                }  
                const fileUpload = await this.profileRepo.update({userId:userId},filesData[0]);
                const updatedData = await this.profileRepo.findOne({
                   where:{userId:userId}
                });
                if(fileUpload) {
                    const da = {
                        userId:updatedData.userId,
                        otherPic: updatedData.profilePic != null ? `${process.env.WORKINGURL}/${updatedData.profilePic}` : '',						
                    }; 
                    response.status = true;
                    response.data   = da;
                    response.statusCode = 50000;
                    response.internalMessage = 'profile picture upload successfully';
                    response.intlCode = 11100;
                } else { 
                    throw new ErrorResponse(11106, 'profile picture not updated')
                }
            } else {
                const oldData = await this.profileRepo.findOne({
                    where:{userId:userId}
                });                
                if(oldData.profilePic != null) {
                    var pary = oldData.profilePic.split('/');
                    var fname = pary[2];
                    if(fname != undefined) {
                        fs.unlinkSync('./public/profilePic/'+fname);
                    }
                }  
                const fileUpload = await this.profileRepo.update({userId:userId},filesData[0]);
                const updatedData = await this.profileRepo.findOne({
                   where:{userId:userId}
                });
                if(fileUpload) {
                    const da = {
                        userId:updatedData.userId,
                        otherPic: updatedData.profilePic != null ? `${process.env.WORKINGURL}/${updatedData.profilePic}` : '',						
                    }; 
                    response.status = true;
                    response.data   = da;
                    response.statusCode = 50000;
                    response.internalMessage = 'profile picture upload successfully';
                    response.intlCode = 11100;
                } else { 
                    throw new ErrorResponse(11106, 'profile picture not updated')
                }
            }      
            return response;
        } catch (error) {
            return errorHandler(GetProfilePicResponseModel, error);
        }
    }

    async getProfileByUserId(queryParams, userId, request:Request):Promise<getMyNetworkResponseModel> {
        const response = new getMyNetworkResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const profile = await this.profileRepo.findOne({
                    relations:['user','user.roles','mandal','village','ward','hamlet'],
                    where:{userId:userId}
                });
                if(profile) {
                    if(profile.profilePic != null) {
                        profile.profilePic = `${process.env.WORKINGURL}/${profile.profilePic}`;
                    }
                    if(profile.membershipImg !=null) {
                        profile.membershipImg = `${process.env.WORKINGURL}/${profile.membershipImg}`;
                    }
                    const welfare = await this.welfareService.getAllActiveWelfareByUID(userId);
                    response.status = true;
                    response.data   = profile;
                    response.welfare=welfare;
                    response.statusCode = 50000;
                    response.internalMessage = 'get profile info successfully';
                    response.intlCode = 11108;
                } else { 
                    throw new ErrorResponse(99998, 'profile info not found')
                }
            } else {
                const profile = await this.profileRepo.findOne({
                    relations:['user','user.roles','mandal','village','ward','hamlet'],
                    where:{userId:userId}
                });
                if(profile) {
                    if(profile.profilePic != null) {
                        profile.profilePic = `${process.env.WORKINGURL}/${profile.profilePic}`;
                    }
                    if(profile.membershipImg !=null) {
                        profile.membershipImg = `${process.env.WORKINGURL}/${profile.membershipImg}`;
                    }
                    const welfare = await this.welfareService.getAllActiveWelfareByUID(userId);
                    response.status = true;
                    response.data   = profile;
                    response.welfare=welfare;
                    response.statusCode = 50000;
                    response.internalMessage = 'get profile info successfully';
                    response.intlCode = 11108;
                } else { 
                    throw new ErrorResponse(99998, 'profile info not found')
                }
            }
            return response;           
        } catch (error) {
            return errorHandler(getMyNetworkResponseModel, error);
        }
    }

    async getUserByUId(userId) {
        const profile = await this.profileRepo.findOne({
            relations:['user','user.roles','mandal','village','ward','hamlet'],
            where:{userId:userId}
        });
        if(profile) { 
            return profile;
        } else {
            return null;
        }
    }

    async getProfileByEmail(email) {
        const profile = await this.profileRepo.findOne({
            relations:['user','user.roles','mandal','village','ward','hamlet'],
            where:{email:email}
        });
        if(profile) { 
            return profile;
        } else {
            return null;
        }
    }

    async getProfileByPhone(mobileNo) {
        const profile = await this.profileRepo.findOne({
            relations:['user','user.roles','mandal','village','ward','hamlet'],
            where:{mobileNo:mobileNo}
        });
        if(profile) { 
            return profile;
        } else {
            return null;
        }
    }

    async deleteUser(userId) {
        const data = await this.profileRepo.update({userId:userId},{status:false});
        if(data) { 
            return true;
        } else {
            return false;
        }
    }

    async getSearchUser(search) {
        const data =await this.profileRepo.find({               
            where: [{mobileNo: Like(`%${search}%`),status: true},
                    {firstName:Like(`%${search}%`),status: true}],
            order: { createdAt: 'DESC' }
        });
        if(data.length > 0) {
            return data;
        }else {
            return null;
        }          
    }

    async getDonorslist(BGroupId,villageId,skip) {
        if(BGroupId > 0 && villageId > 0) {
            var data =await this.profileRepo.find({  
                relations:['bgroup','village'],             
                where: {villageId: villageId,BGroupId:BGroupId,BloodDonner:true,status: true},
                order: { createdAt: 'DESC' },
                skip:skip,
                take: 10
            });
        } else if(BGroupId > 0) {
            var data =await this.profileRepo.find({ 
                relations:['bgroup','village'],              
                where: {BGroupId:BGroupId,BloodDonner:true,status: true},
                order: { createdAt: 'DESC' },
                skip:skip,
                take: 10
            });
        } else if(villageId > 0) {
            var data =await this.profileRepo.find({
                relations:['bgroup','village'],               
                where: {villageId:villageId,BloodDonner:true,status: true},
                order: { createdAt: 'DESC' },
                skip:skip,
                take: 10
            });
        } else {
            var data =await this.profileRepo.find({ 
                relations:['bgroup','village'],              
                where: {BloodDonner:true,status: true},
                order: { createdAt: 'DESC' },
                skip:skip,
                take: 10
            });
        } 
        
        if(data.length > 0) {
            return data;
        }else {
            return null;
        }
    }

    async getMyNetworkByUserId(queryParams, userId, request:Request):Promise<getMyNetworkResponseModel> {
        const response = new getMyNetworkResponseModel();
        try {
            if(!queryParams.skip || queryParams.skip == null) {
                queryParams.skip = 0;
            } 
            const finData: any[] = [];
            if(queryParams.apiVersion == 1) {
                if(queryParams.mandalId > 0 && queryParams.villageId > 0 && queryParams.hamletId > 0) {
                    var data = await this.profileRepo.find({
                        relations:['user','user.roles','mandal','village','ward','hamlet'],
                        where:[{userId:Not(userId),mandalId:queryParams.mandalId,status:true},
                            {userId:Not(userId),villageId:queryParams.villageId,status:true},
                               {userId:Not(userId),hamletId:queryParams.hamletId,status:true}],
                        order: {userId: "DESC"},
                        skip:queryParams.skip,
                        take: 10
                    });
                } else if(queryParams.mandalId > 0 && queryParams.villageId > 0) {
                    var data = await this.profileRepo.find({
                        relations:['user','user.roles','mandal','village','ward','hamlet'],
                        where:[{userId:Not(userId),mandalId:queryParams.mandalId,status:true},
                            {userId:Not(userId),villageId:queryParams.villageId,status:true}],
                        order: {userId: "DESC"},
                        skip:queryParams.skip,
                        take: 10
                    });
                } else if(queryParams.mandalId > 0 && queryParams.hamletId > 0) {
                    var data = await this.profileRepo.find({
                        relations:['user','user.roles','mandal','village','ward','hamlet'],
                        where:[{userId:Not(userId),mandalId:queryParams.mandalId,status:true},
                            {userId:Not(userId),hamletId:queryParams.hamletId,status:true}],
                        order: {userId: "DESC"},
                        skip:queryParams.skip,
                        take: 10
                    });
                }  else if(queryParams.villageId > 0 && queryParams.hamletId > 0) {
                    var data = await this.profileRepo.find({
                        relations:['user','user.roles','mandal','village','ward','hamlet'],
                        where:[{userId:Not(userId),villageId:queryParams.villageId,status:true},
                            {userId:Not(userId),hamletId:queryParams.hamletId,status:true}],
                        order: {userId: "DESC"},
                        skip:queryParams.skip,
                        take: 10
                    });
                } else {
                    var data = await this.profileRepo.find({
                        relations:['user','user.roles','mandal','village','ward','hamlet'],
                        where:{userId:Not(userId),status:true},
                        order: {userId: "DESC"},
                        skip:queryParams.skip,
                        take: 10
                    });
                }

                if(data) {
                    const promises = data.map((p) => {
                        if(p.user.status == true) {
                            return {
                                userId:p.userId,
                                userName: p.firstName,
                                profilePic:p.profilePic,
                                roleId:p.user.roleId,
                                roleName:p.user.roles.roleName,
                                mobileNo: p.mobileNo                                
                            }
                        }                        
                    });
                    const uda = await Promise.all(promises);
                    uda.map((u) => {
                        if(u != undefined) {
                            finData.push({
                                userId:u.userId,
                                userName:u.userName != null ? u.userName:'',
                                profilePic: u.profilePic != null ? `${process.env.WORKINGURL}/${u.profilePic}` : '',
                                mobileNo:u.mobileNo,
                                roleId:u.roleId,
                                roleName:u.roleName
                            })
                        }
                    })
                    if(finData.length > 0) { 
                        response.status = true;
                        response.data = finData;
                        response.statusCode = 50000;
                        response.internalMessage = 'Data retrieved successfully';
                        response.intlCode = 11108;
                    } else {
                        throw new ErrorResponse(99998, 'Data not found');
                    }
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
                
            } else {
                if(queryParams.mandalId > 0 && queryParams.villageId > 0 && queryParams.hamletId > 0) {
                    var data = await this.profileRepo.find({
                        relations:['user','user.roles','mandal','village','ward','hamlet'],
                        where:[{userId:Not(userId),mandalId:queryParams.mandalId,status:true},
                            {userId:Not(userId),villageId:queryParams.villageId,status:true},
                               {userId:Not(userId),hamletId:queryParams.hamletId,status:true}],
                        order: {userId: "DESC"},
                        skip:queryParams.skip,
                        take: 10
                    });
                } else if(queryParams.mandalId > 0 && queryParams.villageId > 0) {
                    var data = await this.profileRepo.find({
                        relations:['user','user.roles','mandal','village','ward','hamlet'],
                        where:[{userId:Not(userId),mandalId:queryParams.mandalId,status:true},
                            {userId:Not(userId),villageId:queryParams.villageId,status:true}],
                        order: {userId: "DESC"},
                        skip:queryParams.skip,
                        take: 10
                    });
                } else if(queryParams.mandalId > 0 && queryParams.hamletId > 0) {
                    var data = await this.profileRepo.find({
                        relations:['user','user.roles','mandal','village','ward','hamlet'],
                        where:[{userId:Not(userId),mandalId:queryParams.mandalId,status:true},
                            {userId:Not(userId),hamletId:queryParams.hamletId,status:true}],
                        order: {userId: "DESC"},
                        skip:queryParams.skip,
                        take: 10
                    });
                }  else if(queryParams.villageId > 0 && queryParams.hamletId > 0) {
                    var data = await this.profileRepo.find({
                        relations:['user','user.roles','mandal','village','ward','hamlet'],
                        where:[{userId:Not(userId),villageId:queryParams.villageId,status:true},
                            {userId:Not(userId),hamletId:queryParams.hamletId,status:true}],
                        order: {userId: "DESC"},
                        skip:queryParams.skip,
                        take: 10
                    });
                } else {
                    var data = await this.profileRepo.find({
                        relations:['user','user.roles','mandal','village','ward','hamlet'],
                        where:{userId:Not(userId),status:true},
                        order: {userId: "DESC"},
                        skip:queryParams.skip,
                        take: 10
                    });
                }

                if(data) {
                    const promises = data.map((p) => {
                        if(p.user.status == true) {
                            return {
                                userId:p.userId,
                                userName: p.firstName,
                                profilePic:p.profilePic,
                                roleId:p.user.roleId,
                                roleName:p.user.roles.roleName,
                                mobileNo: p.mobileNo                                
                            }
                        }                        
                    });
                    const uda = await Promise.all(promises);
                    uda.map((u) => {
                        if(u != undefined) {
                            finData.push({
                                userId:u.userId,
                                userName:u.userName != null ? u.userName:'',
                                profilePic: u.profilePic != null ? `${process.env.WORKINGURL}/${u.profilePic}` : '',
                                mobileNo:u.mobileNo,
                                roleId:u.roleId,
                                roleName:u.roleName
                            })
                        }
                    })
                    if(finData.length > 0) { 
                        response.status = true;
                        response.data = finData;
                        response.statusCode = 50000;
                        response.internalMessage = 'Data retrieved successfully';
                        response.intlCode = 11108;
                    } else {
                        throw new ErrorResponse(99998, 'Data not found');
                    }
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
                
            }
            return response;           
        } catch (error) {
            return errorHandler(getMyNetworkResponseModel, error);
        }
    }
}







